// 検索UI用Vuex
const searchUI = {
  namespaced: true,
  state: {
    // 検索UIの入力欄の値
    inputs: {
      search_text_input: '', // 検索テキスト
      is_fuzzy_input: 0 // 表記の揺れを含む 0=含まない、1=含む
    },
    // 他画面から遷移してきたときに、検索UI(PCSearchUI/SPSearchUI)の検索入力内容を受け渡すための引数
    params: {
      // 検索カテゴリ「QA」の場合のフォームデータ
      qa_search_text_input: '',
      qa_is_fuzzy_input: 0,
      // 検索カテゴリ「書籍」の場合のフォームデータ
      book_search_text_input: '',
      book_is_fuzzy_input: 0,
      // 検索カテゴリ「書式一覧」の場合のフォームデータ
      download_search_text_input: '',
      // 検索カテゴリ「最新ナレッジ」の場合のフォームデータ
      knowledge_search_text_input: '',
      knowledge_is_fuzzy_input: 0,
      // 検索カテゴリ「ノート」の場合のフォームデータ
      note_search_text_input: ''
    }

  },
  getters: {
  },
  mutations: {
    setSearchInputOfSearchUI(state, { searchText, isFuzzy}) {
      if (typeof searchText !== 'string') {
        // 詳細検索の何らかの処理でsearchTextに文字列でなくオブジェクトが設定される場合があり、ここで空文字列に変換しておく。
        searchText = ''
      }
      state.inputs.search_text_input = searchText
      state.inputs.is_fuzzy_input = isFuzzy
    },
    setSearchInputOfSearchUIParam(state, { searchCategory, searchText, isFuzzy}) {
      if (typeof searchText !== 'string') {
        // 詳細検索の何らかの処理でsearchTextに文字列でなくオブジェクトが設定される場合があり、ここで空文字列に変換しておく。
        searchText = ''
      }
      if (searchCategory === 'qa') {
        state.params.qa_search_text_input = searchText
        state.params.qa_is_fuzzy_input = isFuzzy
      } else if (searchCategory === 'knowledge') {
        state.params.knowledge_search_text_input = searchText
        state.params.knowledge_is_fuzzy_input = isFuzzy
      } else if (searchCategory === 'book') {
        state.params.book_search_text_input = searchText
        state.params.book_is_fuzzy_input = isFuzzy
      } else if (searchCategory === 'download') {
        state.params.download_search_text_input = searchText
        // 書式DLに曖昧フラグは存在しない
      } else if (searchCategory === 'note') {
        state.params.note_search_text_input = searchText
        // ノートに曖昧フラグは存在しない
      }
    }
  },
  actions: {
    /** 
     * 検索UIの検索テキストと曖昧フラグを更新する
     */
    setSearchInputOfSearchUI({ commit }, { searchText, isFuzzy}) {
      commit('setSearchInputOfSearchUI', { searchText, isFuzzy})
    },
    /**
     * 次の画面の検索UI(PCSearchUI/SPSearchUI)初期表示のために渡す検索テキスト、曖昧フラグを設定
     */ 
    setSearchInputOfSearchUIParam({ commit }, { searchCategory, searchText, isFuzzy}) {
      commit('setSearchInputOfSearchUIParam', { searchCategory, searchText, isFuzzy})
    }
  }
}

export default searchUI
